import React, {CSSProperties, PropsWithChildren, useMemo} from 'react';
import clsx from 'clsx';

import styles from './WithBorder.module.css';

//Border prop example: 'top left right bottom', 'top bottom'.
//Why not use array? array is hard to maintain due to object equality. And string look nicer also.
interface WithBorderProps {
  className?: string
  borders: string
  borderStyle: string

  onClick?: () => void
}

const bordersConstraint = 'top left right bottom';

const WithBorder = ({borders, borderStyle, className, children}: PropsWithChildren<WithBorderProps>) => {

  const borderClasses = useMemo(() => { //add class no-* to disable border for that side
    let borderWithoutStyleClasses = styles.root;

    borders.split(' ').forEach((border) => {
      if (!bordersConstraint.includes(border)) return;

      borderWithoutStyleClasses += ' ' + styles[border]
    });

    return borderWithoutStyleClasses
  }, [borders]);

  return (
    <div
      className={clsx(styles.root, borderClasses, className)}
      style={{'--with-border': borderStyle} as CSSProperties}
    >
      {children}
    </div>
  );
};

export default WithBorder;